import style from './style.module.scss'

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  checked?: boolean
}

export const Switch = ({ checked, ...props }: Props) => {
  return (
    <label className={style.switch}>
      <input type="checkbox" checked={checked} {...props} />
      <span className={`${style.slider} ${style.round}`}></span>
    </label>
  )
}
